import { createSlice } from '@reduxjs/toolkit';

export const LINK_CLICKS_ACCESS_STATUSES = {
  AVAILABLE: 'available',
  LOCKED: 'locked',
  PREMIUM_REQUIRED: 'premium-required'
};

const mePageData = createSlice({
  name: 'mePageData',
  initialState: {
    linkClicksAccessStatus: null
  },
  reducers: {
    setLinkClicksAccessStatus(state, { payload }) {
      state.linkClicksAccessStatus = payload;
    }
  }
});

export const { setLinkClicksAccessStatus } = mePageData.actions;
export default mePageData.reducer;
